import React, { useState, useRef, useEffect } from "react";

// const data = [
//   { id: 1, titulo: "React", img: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" },
//   { id: 2, titulo: "Vue", img: "https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg" },
//   { id: 3, titulo: "Angular", img: "https://angular.io/assets/images/logos/angular/angular.svg" },
//   { id: 4, titulo: "Svelte", img: "https://upload.wikimedia.org/wikipedia/commons/1/1b/Svelte_Logo.svg" }
// ];

export default function App({Treino, data, AddExecicio, Chave}) {

  const [open, setOpen] = useState(false);
  const [busca, setBusca] = useState("");
  const [selecionado, setSelecionado] = useState(Treino.Nome ? Treino : null);
  const containerRef = useRef(null);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtrados = data.filter(item =>
    item.Nome.toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <div style={{  }}>
      <h5>Exercícios</h5>

      <div
        ref={containerRef}
        style={{
          position: "relative",
          width: 200,
          userSelect: "none"
        }}
      >
        {/* Campo que abre o select */}
        <div
          onClick={() => setOpen(!open)}
          style={{
            border: "1px solid #ccc",
            borderRadius: 5,
            padding: "8px 10px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <span>{selecionado ? selecionado.Nome : "Escolha uma opção"}</span>
          <span style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
        </div>

        {/* Lista suspensa */}
        {open && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              border: "1px solid #ccc",
              borderRadius: 5,
              background: "white",
              maxHeight: 200,
              overflowY: "auto",
              marginTop: 2,
              zIndex: 100
            }}
          >
            {/* Campo de busca dentro do dropdown */}
            <input
              type="text"
              placeholder="Filtrar..."
              value={busca}
              onChange={e => setBusca(e.target.value)}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: 8,
                borderBottom: "1px solid #ccc"
              }}
            />

            {filtrados.map(item => (
              <div
                key={item.Id}
                onClick={() => {AddExecicio(item, Chave); setSelecionado(item); setOpen(false); setBusca(""); }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: 8,
                  cursor: "pointer",
                  background: selecionado?.Id === item.Id ? "#f0f0f0" : "white"
                }}
              >
                <img
                  src={item.UrlTrenio}
                  alt={item.Nome}
                  style={{ width: 50, height: 50, marginRight: 10 }}
                />
                <span style={{ fontSize:13 }}>{item.Nome}</span>
              </div>
            ))}

            {filtrados.length === 0 && (
              <div style={{ padding: 8, color: "#888" }}>Nenhuma opção encontrada</div>
            )}
          </div>
        )}
      </div>

      {/* Exibindo seleção */}
      {selecionado && (
        <div style={{ marginTop: 20 }}>
          <h5>Selecionado:</h5>
          <div >    
          <img
            src={selecionado.UrlTrenio}
            alt={selecionado.Nome}
            style={{ width: 200, height: 200 }}
          />
          <p style={{ marginBottom:1 }}>Categoria - {selecionado.Categoria}</p>
          <p>{selecionado.Nome}</p>
          </div>
        </div>
      )}
    </div>
  );
}
